import { State } from '../default';

const commonState = {
    pending: true,
    error: false,
    fullfilled: false,
}

export const initialState = {
  data: [],
  ...commonState
}

export interface ChildCampaignsState extends State {
  data: any[]
}
